import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdVariantGenerationAssistant } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdVariantGenerationAssistantPayload,
  PostwsGenerativeAiAppGroupIdVariantGenerationAssistantProps,
} from "./types";
import { isVariantGenerationAssistantAsyncResult } from "./validators";

export const postwsGenerativeAiAppGroupIdVariantGenerationAssistant = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdVariantGenerationAssistant,
  async (
    signal,
    {
      appGroupId,
      message,
      count,
      messageType,
      brandGuidelineId,
      toneTypes,
      otherInstructions,
      languageCode,
      coWorkflowId,
      coStepId,
      coComponentName,
      jobToken,
    }: PostwsGenerativeAiAppGroupIdVariantGenerationAssistantProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdVariantGenerationAssistantPayload = {
      job_token: jobToken,
      message,
      count,
      message_type: messageType,
      brand_guideline_id: brandGuidelineId,
      tone_types: toneTypes,
      other_instructions: otherInstructions,
      language_code: languageCode,
      co_workflow_id: coWorkflowId,
      co_step_id: coStepId,
      co_component_name: coComponentName,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/variant_generation_assistant`,
      "POST",
      payload,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isVariantGenerationAssistantAsyncResult
);
